'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Fluent 2 Checkbox Component
 * https://fluent2.microsoft.design/components/web/react/core/field/usage
 * Size: 16x16, rounded corners, brand color when checked
 */
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded border border-neutral-400 transition-colors',
      'ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0c00ff] focus-visible:ring-offset-2',
      'disabled:cursor-not-allowed disabled:opacity-50',
      'hover:border-neutral-600',
      'data-[state=checked]:bg-[#0c00ff] data-[state=checked]:border-[#0c00ff] data-[state=checked]:text-white',
      'dark:border-neutral-500 dark:ring-offset-neutral-950',
      'dark:hover:border-neutral-400',
      'dark:focus-visible:ring-[#479ef5]',
      'dark:data-[state=checked]:bg-[#479ef5] dark:data-[state=checked]:border-[#479ef5] dark:data-[state=checked]:text-neutral-900',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <Check className="h-3 w-3" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }